module.exports = __webpack_public_path__ + "img/Recurso 6.acf1e202.png";